import * as React from 'react';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { OverrideComponent } from '../../../../../renderProps';
import { Sorting } from '../../../../../Results/enums';
import { getIsExchangeAutoMode } from '../../../../../Checkout/store/order/selectors';
import { sortFlights } from '../../../../../Results/components/Results/FlightsList/utils';
import Sortings from '../../../../../Results/components/Results/FlightsList/Sortings/Sortings';
import Disclaimer from '../../../../../Modules/Exchange/components/Exchange/Disclaimer/Disclaimer';
import ResultsError from '../../../../../ResultsError';
import { getFilteredExchangeVariantsOnLeg } from '@entities/exchange';
import { SelectFlight } from '@features/exchange/select-flight';
const SearchFlights = ({ className, controls }) => {
    const { t } = useTranslation('Exchange');
    const { SearchFlights: theme } = useTheme('Widgets').Exchange;
    const [sorting, setSorting] = useState(Sorting.Price);
    const isAutoMode = useSelector(getIsExchangeAutoMode);
    const filteredExchangeFlights = useSelector(getFilteredExchangeVariantsOnLeg);
    const sortedFlights = useMemo(() => {
        return sortFlights(filteredExchangeFlights, sorting);
    }, [filteredExchangeFlights, sorting]);
    const showSortControl = sortedFlights.length > 1;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(theme.root, className) },
            React.createElement("div", { className: theme.content },
                (showSortControl || controls) && (React.createElement("div", { className: theme.controls },
                    showSortControl && React.createElement(Sortings, { onSelect: setSorting, currentSort: sorting }),
                    controls)),
                sortedFlights.length > 0 && (React.createElement("div", { className: theme.notifications },
                    !isAutoMode && React.createElement(Disclaimer, { type: "price" }),
                    React.createElement(Disclaimer, { type: "time" })))),
            sortedFlights.length ? (React.createElement("div", { className: theme.flights }, sortedFlights.map((flight, index) => (React.createElement(SelectFlight, { key: index, flight: flight }))))) : (React.createElement(ResultsError, { header: t(`We couldn't find any flights for given dates`), body: React.createElement(OverrideComponent, { componentProps: {}, component: {
                        ExchangeErrorText: () => (React.createElement("div", { dangerouslySetInnerHTML: {
                                __html: t('Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.')
                            } }))
                    } }) })))));
};
export default SearchFlights;
